/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AdminPermissionModel,
  AdminUserLoggedInResponse,
  AppModel,
  ExchangeTokenModel,
  ExchangeTokenResponse,
  LoginModel,
  MagicLinkRequestedResponse,
  ProblemDetails,
  RequestMagicLinkModel
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Gets app data for the current session.
 */
export const index = (

 signal?: AbortSignal
) => {


      return customAxios<AppModel>(
      {url: `/api/v1/app`, method: 'GET', signal
    },
      );
    }




export const getIndexQueryKey = () => {
    return [
    `/api/v1/app`
    ] as const;
    }


export const getIndexQueryOptions = <TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIndexQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof index>>> = ({ signal }) => index(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type IndexQueryResult = NonNullable<Awaited<ReturnType<typeof index>>>
export type IndexQueryError = ErrorType<void>


export function useIndex<TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof index>>,
          TError,
          Awaited<ReturnType<typeof index>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIndex<TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof index>>,
          TError,
          Awaited<ReturnType<typeof index>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIndex<TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets app data for the current session.
 */

export function useIndex<TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIndexQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getIndexSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIndexQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof index>>> = ({ signal }) => index(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type IndexSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof index>>>
export type IndexSuspenseQueryError = ErrorType<void>


export function useIndexSuspense<TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIndexSuspense<TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useIndexSuspense<TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Gets app data for the current session.
 */

export function useIndexSuspense<TData = Awaited<ReturnType<typeof index>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof index>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getIndexSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Initiates login process for admin users.
 */
export const login = (
    loginModel: LoginModel,
 signal?: AbortSignal
) => {


      return customAxios<AdminUserLoggedInResponse>(
      {url: `/api/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginModel, signal
    },
      );
    }




export const getLoginMutationKey = () => ['login'] as const;

export const getLoginMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext> => {

const mutationKey = getLoginMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof login>>, LoginMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  login(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginMutationResult = NonNullable<Awaited<ReturnType<typeof login>>>
    export type LoginMutationBody = LoginModel
    export type LoginMutationError = ErrorType<ProblemDetails>
    export type LoginMutationVariables = {data: LoginModel}

    /**
 * @summary Initiates login process for admin users.
 */
export const useLogin = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof login>>, TError,LoginMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof login>>,
        TError,
        LoginMutationVariables,
        TContext
      > => {
      return useMutation(getLoginMutationOptions(options), queryClient);
    }
    /**
 * @summary Get's the current user's admin permissions.
 */
export const getAdminPermissions = (

 signal?: AbortSignal
) => {


      return customAxios<AdminPermissionModel[]>(
      {url: `/api/v1/auth/permissions`, method: 'GET', signal
    },
      );
    }




export const getGetAdminPermissionsQueryKey = () => {
    return [
    `/api/v1/auth/permissions`
    ] as const;
    }


export const getGetAdminPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPermissions>>> = ({ signal }) => getAdminPermissions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPermissions>>>
export type GetAdminPermissionsQueryError = ErrorType<ProblemDetails>


export function useGetAdminPermissions<TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPermissions<TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminPermissions>>,
          TError,
          Awaited<ReturnType<typeof getAdminPermissions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPermissions<TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get's the current user's admin permissions.
 */

export function useGetAdminPermissions<TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPermissionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAdminPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminPermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminPermissions>>> = ({ signal }) => getAdminPermissions(signal);





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAdminPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminPermissions>>>
export type GetAdminPermissionsSuspenseQueryError = ErrorType<ProblemDetails>


export function useGetAdminPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get's the current user's admin permissions.
 */

export function useGetAdminPermissionsSuspense<TData = Awaited<ReturnType<typeof getAdminPermissions>>, TError = ErrorType<ProblemDetails>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAdminPermissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminPermissionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Initiates login process for admin users via email verification and magic link.
 */
export const loginByEmail = (
    requestMagicLinkModel: RequestMagicLinkModel,
 signal?: AbortSignal
) => {


      return customAxios<MagicLinkRequestedResponse>(
      {url: `/api/v1/auth/request-magic-link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestMagicLinkModel, signal
    },
      );
    }




export const getLoginByEmailMutationKey = () => ['loginByEmail'] as const;

export const getLoginByEmailMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginByEmail>>, TError,LoginByEmailMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof loginByEmail>>, TError,LoginByEmailMutationVariables, TContext> => {

const mutationKey = getLoginByEmailMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginByEmail>>, LoginByEmailMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  loginByEmail(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LoginByEmailMutationResult = NonNullable<Awaited<ReturnType<typeof loginByEmail>>>
    export type LoginByEmailMutationBody = RequestMagicLinkModel
    export type LoginByEmailMutationError = ErrorType<unknown>
    export type LoginByEmailMutationVariables = {data: RequestMagicLinkModel}

    /**
 * @summary Initiates login process for admin users via email verification and magic link.
 */
export const useLoginByEmail = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginByEmail>>, TError,LoginByEmailMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginByEmail>>,
        TError,
        LoginByEmailMutationVariables,
        TContext
      > => {
      return useMutation(getLoginByEmailMutationOptions(options), queryClient);
    }
    /**
 * @summary Records the acting admin switching into (or first entering) a platform, stamping it as
their last-used platform. The admin portal calls this when the platform switcher changes
platforms; login-attempt events then carry the resulting last-used platform.
 */
export const switchPlatform = (
    platformId: string,
 signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/auth/platforms/${platformId}/switch`, method: 'POST', signal
    },
      );
    }




export const getSwitchPlatformMutationKey = () => ['switchPlatform'] as const;

export const getSwitchPlatformMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchPlatform>>, TError,SwitchPlatformMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof switchPlatform>>, TError,SwitchPlatformMutationVariables, TContext> => {

const mutationKey = getSwitchPlatformMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchPlatform>>, SwitchPlatformMutationVariables> = (props) => {
          const {platformId} = props ?? {};

          return  switchPlatform(platformId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SwitchPlatformMutationResult = NonNullable<Awaited<ReturnType<typeof switchPlatform>>>

    export type SwitchPlatformMutationError = ErrorType<ProblemDetails>
    export type SwitchPlatformMutationVariables = {platformId: string}

    /**
 * @summary Records the acting admin switching into (or first entering) a platform, stamping it as
their last-used platform. The admin portal calls this when the platform switcher changes
platforms; login-attempt events then carry the resulting last-used platform.
 */
export const useSwitchPlatform = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchPlatform>>, TError,SwitchPlatformMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof switchPlatform>>,
        TError,
        SwitchPlatformMutationVariables,
        TContext
      > => {
      return useMutation(getSwitchPlatformMutationOptions(options), queryClient);
    }
    /**
 * @summary Completes magic-link login by exchanging the emailed token for an admin auth token.
 */
export const exchangeToken = (
    exchangeTokenModel: ExchangeTokenModel,
 signal?: AbortSignal
) => {


      return customAxios<ExchangeTokenResponse>(
      {url: `/api/v1/auth/exchange-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: exchangeTokenModel, signal
    },
      );
    }




export const getExchangeTokenMutationKey = () => ['exchangeToken'] as const;

export const getExchangeTokenMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,ExchangeTokenMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,ExchangeTokenMutationVariables, TContext> => {

const mutationKey = getExchangeTokenMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof exchangeToken>>, ExchangeTokenMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  exchangeToken(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExchangeTokenMutationResult = NonNullable<Awaited<ReturnType<typeof exchangeToken>>>
    export type ExchangeTokenMutationBody = ExchangeTokenModel
    export type ExchangeTokenMutationError = ErrorType<unknown>
    export type ExchangeTokenMutationVariables = {data: ExchangeTokenModel}

    /**
 * @summary Completes magic-link login by exchanging the emailed token for an admin auth token.
 */
export const useExchangeToken = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof exchangeToken>>, TError,ExchangeTokenMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof exchangeToken>>,
        TError,
        ExchangeTokenMutationVariables,
        TContext
      > => {
      return useMutation(getExchangeTokenMutationOptions(options), queryClient);
    }
